import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChain } from '@fortawesome/pro-solid-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { AuthPageWrapper, TextField } from '@app/components';
import { authMessages, sharedMessages } from '@app/translations';
import { emailValidationRegex } from '@app/constants';

import './ResendEmailForm.scss';

interface ResendEmailFormProps {
  title: string;
  subtitle: string;
  onSubmit: () => void;
}

const cnBem = createBemBlockBuilder(['resendEmailForm']);

export const ResendEmailForm: FC<ResendEmailFormProps> = ({
  title,
  subtitle,
  onSubmit,
}) => {
  const { $t } = useIntl();
  const form = useForm({ mode: 'onChange' });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isValid, isDirty },
  } = form;

  return (
    <AuthPageWrapper className={cnBem()}>
      <AuthPageWrapper.Form onSubmit={handleSubmit(onSubmit)}>
        <FontAwesomeIcon icon={faChain} className={cnBem('__icon')} />
        <AuthPageWrapper.FormTitle titleLevel={1}>
          {title}
        </AuthPageWrapper.FormTitle>
        <AuthPageWrapper.RowMessage data-auto="resend-email-form-subtitle">
          {subtitle}
        </AuthPageWrapper.RowMessage>
        <AuthPageWrapper.Row>
          <TextField
            label={$t(authMessages.emailAddress)}
            name="email"
            type="email"
            rules={{
              required: $t(sharedMessages.required),
              pattern: {
                value: emailValidationRegex,
                message: $t(authMessages.emailValidationMessage),
              },
            }}
            control={control}
          />
        </AuthPageWrapper.Row>
        <AuthPageWrapper.Row>
          <AuthPageWrapper.SubmitButton
            isDisabled={!isValid || isSubmitting || !isDirty}
          >
            {$t({
              id: 'preregistration.resendLink',
              defaultMessage: 'Resend link',
            })}
          </AuthPageWrapper.SubmitButton>
        </AuthPageWrapper.Row>
      </AuthPageWrapper.Form>
    </AuthPageWrapper>
  );
};
